module.exports = __webpack_public_path__ + "img/physics2.7d0d8c45.png";